import { Grid, makeStyles } from '@material-ui/core';
import InfinityScroll from 'components/Shared/InfinityScroll';
import { ISavedLesson } from 'interface/savedLesson';
import React from 'react';
import SavedLessonCard from '../Card';
import SavedLessonSkeleton from '../Skeleton';

interface IProps {
  savedLessons: ISavedLesson[];
  handleRemoveLessonSaved: (lessonId: number) => void;
  handleEndReached: () => void;
  loading: boolean;
}

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
}));

const LessonList: React.FC<IProps> = ({ savedLessons, loading, handleEndReached, handleRemoveLessonSaved }) => {
  const classes = useStyles();

  return (
    <Grid>
      <Grid>
        {savedLessons.length == 0 && loading && (
          <>
            <SavedLessonSkeleton />
            <SavedLessonSkeleton />
            <SavedLessonSkeleton />
            <SavedLessonSkeleton />
          </>
        )}
        <InfinityScroll onScrollToBottom={handleEndReached} bottomDistance={50}>
          <Grid className={classes.cardContainer}>
            {savedLessons.length >= 1 &&
              savedLessons.map((savedLesson) => (
                <Grid key={savedLesson.id} className={classes.cardContainer}>
                  <SavedLessonCard {...savedLesson} handleRemove={handleRemoveLessonSaved} />
                </Grid>
              ))}
          </Grid>
        </InfinityScroll>
      </Grid>
    </Grid>
  );
};

export default LessonList;
